import type { TEmitterType } from '@semios/app-platform-values-helpers-and-types'
import { translate } from 'i18n/i18n'
import { captureFrontendError } from 'utils/captureFrontendError'

export const mapApiEmitterTypeToLabel = (emitterType: TEmitterType) => {
  switch (emitterType) {
    case 'emitter-buried-drip-1':
      return translate.phrases.emitterTypes('Buried Drip 1')

    case 'emitter-buried-drip-2':
      return translate.phrases.emitterTypes('Buried Drip 2')

    case 'emitter-drip-1':
      return translate.phrases.emitterTypes('Drip 1')

    case 'emitter-drip-2':
      return translate.phrases.emitterTypes('Drip 2')

    case 'emitter-microspray':
      return translate.phrases.emitterTypes('Microspray')

    case 'emitter-sprinkler':
      return translate.phrases.emitterTypes('Sprinkler')

    case 'emitter-flood-furrow':
      return translate.phrases.emitterTypes('Flood Furrow')

    case 'emitter-overhead-cooling-microspray':
      return translate.phrases.emitterTypes('Overhead Cooling Microspray')

    case 'emitter-overhead-cooling-sprinkler':
      return translate.phrases.emitterTypes('Overhead Cooling Sprinkler')

    case 'emitter-other':
      return translate.phrases.emitterTypes('Other')

    case 'valve-1':
      return translate.phrases.emitterTypes('Valve 1')

    case 'valve-2':
      return translate.phrases.emitterTypes('Valve 2')

    case 'valve-3':
      return translate.phrases.emitterTypes('Valve 3')

    case 'valve-4':
      return translate.phrases.emitterTypes('Valve 4')

    case 'valve-5':
      return translate.phrases.emitterTypes('Valve 5')

    case 'valve-6':
      return translate.phrases.emitterTypes('Valve 6')

    case 'valve-7':
      return translate.phrases.emitterTypes('Valve 7')

    case 'valve-8':
      return translate.phrases.emitterTypes('Valve 8')

    case 'valve-9':
      return translate.phrases.emitterTypes('Valve 9')

    case 'valve-10':
      return translate.phrases.emitterTypes('Valve 10')

    case 'pump':
      return translate.phrases.emitterTypes('Pump')

    case 'pre-filter':
      return translate.phrases.emitterTypes('Pre-filter')

    case 'post-filter':
      return translate.phrases.emitterTypes('Post-filter')

    case 'system-pressure':
      return translate.phrases.emitterTypes('Pressure Switch')

    default: {
      emitterType satisfies never

      captureFrontendError(`${JSON.stringify({ emitterType })} has not been implemented`)

      return emitterType
    }
  }
}
